import React, { Component } from 'react'
import FontW9 from "../Font/FontW9";
import FontW7 from "../Font/FontW7";
import { withStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
const styles = theme =>({
    imgSize: {
        width:'275px' ,
        margin:'auto',
        [theme.breakpoints.down('sm')]: {
            width:'230px',
        },
    },
    opacityClient: {
        position: 'absolute',
        backgroundColor: 'black',
        zIndex: 5,
        width: '100%',
        height: '100%',
        opacity: 0.2
    },
    box:{
        paddingTop: '10px',
        width: '100%',
        height: 100,
        margin: 'auto'
    },
    divCenter:{
        position:'absolute',
        alignItems:'center',
        width:'100%',
        margin:'auto',
        paddingTop:30
    },
    height:{
        height:'500px',
        position:'relative',
        [theme.breakpoints.down('sm')]: {
            height:'320px',
        },
    },
    zIndexTitle:{},
    togo:{
        padding: 0,
        margin: 0,
        listStyle: 'none',
        display: 'flex',
        webkitFlexFlow: 'row wrap',
        justifyContent: 'space-around',
        width:'fit-content',
        height:'fit-content'
    },
    img:{
        minHeight: '10vh',
        height:'316px',
        minWidth: '7vw',
        // width:'100%',
        position:'relative'
    }

})

class BoxsSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth/3-60
        };
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize)
    }

    handleResize = () =>{
        this.setState({
            width: window.innerWidth/3-60
        })
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize)
    }

    render() {
        // const heights = this.state.width

        const { classes, setMargin} = this.props
        return (
            <div id="three-boxs" className={"clearfix " + setMargin} style={{border: '2px solid black'}}>
                <Grid container className="no-padding" style={{float:'left',width:'100%'}}>
                    <Grid item md={4} xs={12} style={{position:'relative'}}>
                        <div className="icon-box" style={{top:'5%',position:'absolute',zIndex:10,marginLeft:'5%'}}>
                            <div style={{ fontSize: "14pt"}} className={classes.imgSize}><FontW7>無料提供１</FontW7></div>
                            <span style={{fontSize:"20pt"}} className={classes.imgSize}><FontW9 className="black">じぶん発揮力診断</FontW9></span>
                        </div>
                        <div style={{height:'316px',backgroundColor:'#FFF',textAlign:'center',}}>
                            <img className={classes.img} src={'img/box3.png'}/>
                        </div>
                    </Grid>

                    <Grid item md={4} xs={12} style={{position:'relative'}}>
                        <div className="icon-box" style={{top:'5%',position:'absolute',zIndex:10,marginLeft:'5%'}}>
                            <div style={{ fontSize: "14pt",color:'#FFF' }}><FontW7>無料提供２</FontW7></div>
                            <span style={{fontSize:"20pt",color:'#FFF' }}><FontW9>パフォーマンス支援AI</FontW9></span>
                        </div>
                        <div style={{height:'316px',width:'100%',backgroundImage:"url('img/togo-8.png')", backgroundPosition:'center', textAlign:'center'}}>
                        </div>
                    </Grid>

                    <Grid item md={4} xs={12} style={{position:'relative'}}>
                        <div className={classes.opacityClient}/>
                        <div className="icon-box" style={{top:'5%',position:'absolute',zIndex:10,marginLeft:'5%'}}>
                            <div style={{ fontSize: "14pt",color:'#FFF'  }}><FontW7>無料提供３</FontW7></div>
                            <span style={{fontSize:"20pt",color:'#FFF' }}><FontW9>統合Identity研究podcast</FontW9></span>
                        </div>
                        <div style={{height:'316px',backgroundColor:'#FFF',textAlign:'center'}}>
                            <img className={classes.img} src={'img/ikuta_big3.png'}/>
                        </div>
                    </Grid>

                </Grid>
            </div>
        )
    }
}

export default withStyles(styles)(BoxsSection)
